'use strict';

angular.module('app.home.kpi', []);